import { Injectable, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class DomService {
  private metaService = inject(Meta);
  private titleService = inject(Title);

  updateTitle(title: string): void {
    this.titleService.setTitle(title);
  }

  updateMetaNameTag(name: string, content?: string): void {
    if (!content) {
      this.metaService.removeTag(`name="${name}"`);
      return;
    }

    if (this.metaService.getTag(`name="${name}"`)) {
      this.metaService.updateTag({ name, content });
    } else {
      this.metaService.addTag({ name, content });
    }
  }

  updateMetaPropertyTag(property: string, content?: string): void {
    if (!content) {
      this.metaService.removeTag(`property="${property}"`);
      return;
    }

    if (this.metaService.getTag(`property="${property}"`)) {
      this.metaService.updateTag({ property, content });
    } else {
      this.metaService.addTag({ property, content });
    }
  }
}
